import useUser from '../../../contexts/hooks/useUser'
import { trpc } from '../../../modules/trpc'
import { getSortedTrackers } from '../utils/getSortedTrackers'

export type TrackersHook = ReturnType<typeof useTrackers>

const useTrackers = () => {
	const utils = trpc.useContext()

	const { user } = useUser()

	const { data, isLoading, isFetching, refetch } = trpc.trackers.get.useQuery(
		{ userId: user?.id ?? 0 },
		{ onSuccess: data => getSortedTrackers(data), enabled: !!user?.id }
	)

	const mutate = trpc.trackers.edit.useMutation({
		onSuccess: data => {
			if (data?.userId && user?.id === data.userId) {
				utils.achievements.getUserAchievements.invalidate(user.id)
				utils.achievements.getUserTotalPoints.invalidate({ userId: user.id })
				utils.achievements.getUserCurrentLevel.invalidate({ userId: user.id })
			}
		},
	})

	return {
		data,
		isLoading,
		isFetching,
		mutate,
		refetch,
	}
}

export default useTrackers
